import React from 'react';
import PropTypes from 'prop-types';
import themeable from 'zignal-landscape/lib/themeable';
import Loading from 'zignal-landscape/lib/Loading';
import { ANTTABLE as Table } from 'zignal-landscape/lib/Table';
import OverviewStory from 'containers/TrendingStoriesOverview/components/OverviewStory';
import InfoBox from 'containers/TrendingStoriesOverview/components/InfoBox';

const getColumns = (timezone) => ([
  {
    title: 'Date',
    dataIndex: 'createdAt',
    sortDirections: ['descend', 'ascend', 'descend'],
    render: (text, record, index) => ({
      children: <OverviewStory
        rank={index + 1}
        story={record}
        index={index}
        timezone={timezone}
      />,
      props: {
        colSpan: 2,
      }
    }),
    sorter: (a, b) => {
      const aDate = (new Date(a.createdAt)).getTime();
      const bDate = (new Date(b.createdAt)).getTime();
      return aDate - bDate;
    }
  },
  {
    title: 'Retweets',
    dataIndex: 'retweetCount',
    sortDirections: ['descend', 'ascend', 'descend'],
    defaultSortOrder: 'descend',
    render: () => ({
      children: null,
      props: {
        colSpan: 0
      }
    }),
    sorter: (a, b) => {
      return a.retweetCount - b.retweetCount;
    }
  },
]);

class TweetsPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      containerHeight: 0,
    };
    this.containerDiv = null;
  }

  componentDidMount() {
    const { onFetchTweets } = this.props;
    // set container height to have ant table fixed header

    // eslint-disable-next-line
    this.setState({
      containerHeight: this.containerDiv.clientHeight,
    });

    onFetchTweets();
  }

  renderLoadingWrapper() {
    const { styles } = this.props;
    return (
      <div className={styles.loadingWrapper}>
        <Loading width="3em" height="3em" />
      </div>
    );
  }

  renderTable() {
    const { timezone, styles, tweets, tweetsLoading, tweetsLoadError} = this.props;
    const { containerHeight } = this.state;

    return (<div>
      <Table
        columns={getColumns(timezone)}
        size="small"
        className={styles.customTable}
        data={tweets.stories}
        loading={{
          spinning: tweetsLoading,
          indicator: this.renderLoadingWrapper()
        }}
        rowExpandable={() => false}
        yScroll={containerHeight - 98}
        showExpandableRows={false}
        rowKey={(record) => record.external_id}
        hidePagination
      />
      {
        !tweetsLoading &&
        !tweetsLoadError &&
        (tweets.stories && tweets.stories.length === 0) &&
        <InfoBox message="No Popular Tweets Available." hideIcon small />
      }
    </div>);
  }

  renderSummary() {
    const { tweets } = this.props;

    if (tweets && tweets.stories) {
      if (tweets.stories.length >= 50) {
        return <span className="tweets-summary">(Top 50)</span>;
      }
      return null;
    }
    return null;
  }

  render() {
    const {styles, tweetsLoadError, shortDateString} = this.props;

    return (
      <div
        className={`${styles.tweetspageContainer} trending-stories-overview-tab-tweets`}
        ref={(ref) => { this.containerDiv = ref; }}
      >
        <h3 className={styles.tabTitle} data-cy="overviewTabTitle">Popular Tweets
          <span className={styles.normalSize}> &nbsp; {shortDateString}</span> {this.renderSummary()}</h3>
        <div className={styles.tableContainer}>
          {tweetsLoadError &&
            <InfoBox message="An error happened while trying to load the tweets, please try again later." />}
          {!tweetsLoadError && this.renderTable()}
        </div>
      </div>
    );
  }
}

TweetsPage.propTypes = {
  styles: PropTypes.object.isRequired,
  tweets: PropTypes.object.isRequired,
  timezone: PropTypes.string.isRequired,
  onFetchTweets: PropTypes.func.isRequired,
  shortDateString: PropTypes.string,
  tweetsLoading: PropTypes.bool.isRequired,
  tweetsLoadError: PropTypes.any,
};

TweetsPage.defaultProps = {
  tweetsLoadError: null,
};

export default themeable(TweetsPage);
